export const accessApp = {
  appId: 'ch.quilvest.accessapp',
  uri: 'qvsaccess://x-callback-url/authenticate',
  deepLinks: {
    authentication: {
      success: 'qvsbanking://authenticationSuccess',
      cancel: 'qvsbanking://authenticationCancel',
      error: 'qvsbanking://authenticationError'
    },
    paymentConfirmation: {
      success: 'qvsbanking://paymentConfirmationSuccess',
      cancel: 'qvsbanking://paymentConfirmationCancel',
      error: 'qvsbanking://paymentConfirmationError'
    }
  }
};
